module.exports = "/img/videos/0.9961e7.mp4";